<template>
    <el-input v-model="value"></el-input>
</template>

<script>
import {watch, ref} from 'vue'
import {compute,fetchFields} from '@/utils/ExpressionComputer'
export default {
    name:'ComputedWidget',
    computed:{
        value:{
            get(){
                return this.innerValue
            },
            set(value){
                this.innerValue = value
                this.$emit('update:modelValue', value)
            }
        }
    },
    emits:['update:modelValue'],
    props:['modelValue', 'parentFormData', 'expression'],
    setup(props,{emit}){
        const innerValue = ref(props.modelValue);
        if(props.parentFormData && props.expression){
            const fields = fetchFields(props.expression)
            watch(
                ()=>{                    
                    const ar = fields.map((f)=>props.parentFormData[f])
                    return ar;
                },
                ()=>{                                
                    innerValue.value = compute(props.expression, props.parentFormData)
                    emit('update:modelValue', innerValue.value)
                })
        }
        return {innerValue}

    }
}
</script>
